import { ReactElement, useState } from 'react';
import './App.scss';
import GamePortfolio from './components/GamePortfolio/GamePortfolio';
import StandardPortfolio from './components/StandardPortfolio/StandardPortfolio';
import Portfolio from "./core/enums/Portfolio";

export interface IProps { //TODO: move to different file?
  changeLocation: (newState: Portfolio) => void
}

function App(): JSX.Element {
  const [location, setLocation] = useState(Portfolio.Game);

  const changeLocation = (newLocation: Portfolio): void => {
    setLocation(newLocation);
  }

  const loadLocation = (state: Portfolio): ReactElement => {
    switch (state) {
      case Portfolio.Game:
        return <GamePortfolio changeLocation={changeLocation} />
      case Portfolio.Standard:
        return <StandardPortfolio changeLocation={changeLocation} />
    }
  }

  return (
    <div className="app">
      { loadLocation(location) }
    </div>
  );
}

export default App;
